import $ from "jquery";
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import Moment from 'react-moment';
import SessionManager from '../../routes/SessionManager';

function ZoneHistoryCalendar(props) {

    const [date, setDate] = useState(props.date);
    const [endDate, setEndDate] = useState(props.end_date);
    const [zone_calendar, setZoneCalendar] = useState(null);

    let user = new SessionManager().readCookie('user');
    let timezone = user.site_selected.site_iana_timezone;
    if (!timezone)
        timezone = moment.tz.guess();

    useEffect(() => {
        setDate(props.date);
        setEndDate(props.end_date);
    }, [props])

    useEffect(() => {
        fetchZoneCalendar();
    }, [date, endDate])

    const fetchZoneCalendar = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            location_id: user.zone_selected.location_id,
            image_calendar: true,
            to: endDate,//moment(this.date).add(6, 'days').format('YYYY-MM-DD'),
            from: date,//moment(this.date).add(-1, 'days').format('YYYY-MM-DD'),
            timezone: timezone
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/zone-history',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    setZoneCalendar(res.data);
                }
            },
            (res) => {

            });
    }

    return (
        <div className="row">
            {
                zone_calendar && zone_calendar.map((zone_date_rec, idx) => (
                    idx < 7 && <div className="col-md-6 col-4 p-2" key={idx} >
                        <div className="card cursor-pointer" onClick={() => props.onZoneDateClick(zone_date_rec)}>
                            <img className="card-img-top" src={zone_date_rec.image_thumbnail} alt='Zone Date' width='100px'></img>
                            <div className="card-footer p-0 text-center bg-primary">
                                <span className="card-title font-size-12 text-white">
                                    <Moment format="YYYY-MM-DD" tz={user.site_selected.site_iana_timezone}>
                                        {zone_date_rec.dev_timestamp * 1000}
                                    </Moment>
                                </span>
                            </div>
                        </div >
                    </div >
                ))
            }

        </div>
    );
}

export default ZoneHistoryCalendar;